import getAccessByURLPath from '../constants/pageAccess';

const getPageRouteListHavingDefaultProperties = (routeList) => {
   return routeList.map((routeItem) => ({
      ...routeItem,
      access: routeItem?.access === undefined
         ? getAccessByURLPath(routeItem?.path)
         : routeItem.access,
   }));
};

export default {
   getPageRouteListHavingDefaultProperties,
};
